export default "https://static.zego.com/_next/static/chunks/fonts/ModernEra-BoldItalic-e80b62d15d07d453ae3956cfb8db4fad.woff";